import { Box, Stack, Typography } from '@mui/material';
import { useAppSelector } from 'core/store/hooks';
import TooltipIcon from 'pages/PlaygroundV2Page/components/TooltipIcon';
import { containsInteger, getErrorText, isTooLongText } from 'pages/PlaygroundV2Page/helpers';
import { DARKER_GREY, GREY, RED } from 'utils/theme';
import Loading from '../../Loading';
import React from 'react';

const LeftSide = () => {
  const isClaimLoading = useAppSelector((state) => state.claimsV2.isClaimLoading);
  const claim = useAppSelector((state) => state.claimsV2.claims[0]);
  const claimHasEvidence = claim?.evidence && claim.evidence?.length > 0;

  const searchValue = useAppSelector((state) => state.claimsV2.searchValue);

  const labels = [
    'Searching for the most credible references on Google and Bing',
    'Searching for the most credible references on You.com',
    'Searching for the most credible research articles through Semantic Scholar',
    'Looking for relevant fact-checks in FactiSearch (400k+ fact-checks)',
    'Evaluating credibility of results',
    'Categorizing references as supporting, disputing or neutral',
    'Factiverse always looks for the most credible references, in real-time',
    'You can check any textual content in 114 languages!',
    'We are built on high-quality training data from certified fact-checking organizations',
    "We don't use any Generative AI, providing a higher accuracy and veracity rate.",
  ];

  const searchContainInteger = containsInteger(searchValue);

  const TooltipText =
    'Always double check references when using numbers in your claims, as they are the most difficult to verify.';

  return (
    <Box data-testid="searchFieldFooterLeft">
      {isClaimLoading ? (
        <Loading labels={labels} />
      ) : (
        <>
          {!claimHasEvidence && (
            <Box>
              {getErrorText(searchValue) ? (
                <Box display="flex">
                  <Typography
                    sx={{
                      color: isTooLongText(searchValue) ? RED : GREY,
                      fontSize: {
                        desktop: '14px',
                        tablet: '14px',
                        mobile: '12px',
                      },
                    }}
                  >
                    {getErrorText(searchValue)}
                  </Typography>
                </Box>
              ) : searchContainInteger ? (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <TooltipIcon tooltip={TooltipText} sx={{ marginTop: '4px' }} />
                  <Typography
                    color={DARKER_GREY}
                    sx={{
                      fontSize: {
                        desktop: '14px',
                        tablet: '14px',
                        mobile: '12px',
                      },
                      alignContent: 'center',
                    }}
                  >
                    Numbers in your claims
                  </Typography>
                </Stack>
              ) : (
                <Box display="flex">
                  <Typography
                    sx={{
                      color: isTooLongText(searchValue) ? RED : GREY,
                      fontSize: {
                        desktop: '14px',
                        tablet: '14px',
                        mobile: '12px',
                      },
                    }}
                  >
                    {'Check short claims or analyze a longer text'}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default LeftSide;
